import $ from 'jquery';
import get from 'lodash/get';
import removeQueryParam from '../../helpers/remove-query-param';

export default function(){
    const openMenu = get(window, 'rcProps.trigger.global.openMenu', false);
    if (openMenu === true || openMenu === 'true') {
        $('#tr-burger-icon').trigger('click');
        removeQueryParam('openMenu');
    }
};



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/header/amp-open-menu.js